// VIEWS
export const CHANNEL_OVERLAP = 'channel_overlap';
export const CONVERSION_FUNNEL = 'conversion_funnel';
export const CROSS_CHANNEL_REPORT = 'cross_channel_report';
export const DATA_WAREHOUSE = 'data_warehouse';
export const EVENT_STATUS = 'event_status';
export const FUNNEL_POSITION = 'funnel_position';
export const GOALS_AND_RECS = 'goals_and_recs';
export const GOOGLE_SHEETS_PLUGIN = 'google_sheets_plugin';
export const HOME = 'home';
export const INTEGRATIONS = 'integrations';
export const MARKETING_MIX_MODELING = 'marketing_mix_modeling';
export const MARKETING_PATHS = 'marketing_paths';
export const PLATFORM_PERFORMANCE = 'platform_performance';
export const PLATFORM_PERFORMANCE_BENCHMARKS = 'platform_performance_benchmarks';
export const PROMO_CODES = 'promo_codes';
export const ROCKERBOX_PERFORMANCE = 'rockerbox_performance';
export const SAVED_REPORTS = 'saved_reports';
export const SETTINGS_COLORS = 'settings_colors';
export const SETTINGS_CONVERSION_FUNNEL = 'settings_conversion_funnel';
export const SETTINGS_DOMAINS = 'settings_domains';
export const SETTINGS_MY_ACCOUNT = 'settings_my_account';
export const SETTINGS_TEAM_USERS = 'settings_team_users';
export const SPEND_TRENDS = 'spend_trends';
export const SURVEYS = 'surveys';
export const TESTING = 'testing';
export const UNIFIED = 'marketing_mix_modeling'; // UPDATE when oso has correct view name
